import baseUrl from '@/assets/js/baseUrl.js';
import http from './http'

export var newCompany = {
  //首页
  // 公司信息
  getInfo(params) {
    return http.post(`${baseUrl}NewIndex/info`, params)
  },
  // 引导步骤
  editNextJson(params) {
    return http.post(`${baseUrl}NewIndex/editNextJson`, params)
  },
  // 用户协议
  userProtocol(params) {
    return http.post(`${baseUrl}NewIndex/userProtocol`, params)
  },
  // 记录下载信息
  recordDownload(params) {
    return http.post(`${baseUrl}NewIndex/recordDownload`, params)
  },
  // 下载列表
  listDownload(params) {
    return http.post(`${baseUrl}NewIndex/listDownload`, params)
  },
  // 修改企业管理员
  adminUser(params) {
    return http.post(`${baseUrl}NewIndex/adminUser`, params)
  },

  //差旅服务设置
  //设置结算方式
  editCustomerPaytype(params) {
    return http.post(`${baseUrl}NewIndex/editCustomerPaytype`, params)
  },
  settlement(params) {
    return http.post(`${baseUrl}NewIndex/settlement`, params)
  },
  //开通月结审批
  openMoonExamine(params) {
    return http.post(`${baseUrl}NewIndex/openMoonExamine`, params)
  },
  //设置费用归属-项目中心
  customerProject(params) {
    return http.post(`${baseUrl}NewIndex/customerProject`, params)
  },
  //设置费用归属-新增或编辑项目中心
  editProject(params) {
    return http.post(`${baseUrl}NewIndex/editProject`, params)
  },
  //删除项目中心
  deleteProject(params) {
    return http.post(`${baseUrl}NewIndex/deleteProject`, params)
  },
  //设置费用归属-发票抬头
  customerInvoiceList(params) {
    return http.post(`${baseUrl}NewIndex/customerInvoiceList`, params)
  },
  //发票抬头文档
  wordInvoice(params) {
    return http.post(`${baseUrl}NewIndex/wordInvoice`, params)
  },
  //新增或修改发票抬头
  editCustomerInvoice(params) {
    return http.post(`${baseUrl}NewIndex/editCustomerInvoice`, params)
  },
  //删除发票抬头
  deleteInvoice(params) {
    return http.post(`${baseUrl}NewIndex/deleteInvoice`, params)
  },
  //开启预定服务
  openService(params) {
    return http.post(`${baseUrl}NewIndex/openService`, params)
  },
  //修改预定服务
  editServiceOpen(params) {
    return http.post(`${baseUrl}NewIndex/editServiceOpen`, params)
  },
  //差旅管理
  //差旅标准设置列表
  travelConfigList(params) {
    return http.post(`${baseUrl}NewIndex/travelConfigList`, params)
  },
  //差旅标准设置模板
  travelConfigTemplate(params) {
    return http.post(`${baseUrl}NewIndex/travelConfigTemplate`, params)
  },
  //差旅标准城市搜索
  getCityByKeyword(params) {
    return http.post(`${baseUrl}NewIndex/getCityByKeyword`, params)
  },
  //差旅标准设置新增和修改
  editTravelConfigList(params) {
    return http.post(`${baseUrl}NewIndex/editTravelConfigList`, params)
  },
  //差旅标准设置删除
  deleteTravelConfigList(params) {
    return http.post(`${baseUrl}NewIndex/deleteTravelConfigList`, params)
  },
  //消息接受设置查询
  getCustomerMsg(params) {
    return http.post(`${baseUrl}NewIndex/getCustomerMsg`, params)
  },
  //消息接受设置新增和修改
  editCustomerMsg(params) {
    return http.post(`${baseUrl}NewIndex/editCustomerMsg`, params)
  },
  //消息接受管理理由查询
  getTravelManage(params) {
    return http.post(`${baseUrl}NewIndex/getTravelManage`, params)
  },
  //差旅标准管理总新增和修改
  editTravelManage(params) {
    return http.post(`${baseUrl}NewIndex/editTravelManage`, params)
  },
  //人员管理
  //人员管理总常旅客列表
  getTravelList(params) {
    return http.post(`${baseUrl}NewIndex/getTravelList`, params)
  },
  // 获取组织机构列表
  getFormTreeList(params) {
    return http.post(`${baseUrl}Org/formTree`, params)
  },
  // 人员管理总常旅客新增
  addTravel(params) {
    return http.post(`${baseUrl}NewIndex/addTravel`, params)
  },
  // 人员管理总常旅客修改
  editTravel(params) {
    return http.post(`${baseUrl}NewIndex/editTravel`, params)
  },
  // 人员管理总常旅客删除
  delTravel(params) {
    return http.post(`${baseUrl}NewIndex/delTravel`, params)
  },
  // 人员管理常旅客负责人修改
  editTravelWhite(params) {
    return http.post(`${baseUrl}NewIndex/editTravelWhite`, params)
  },
  //企业账单
  //消费订单
  reportDetails(params) {
    return http.post(`${baseUrl}NewIndex/reportDetails`, params)
  },
  //账单明细
  reportList(params) {
    return http.post(`${baseUrl}NewIndex/reportList`, params)
  },
  //差旅总览
  dateAll(params) {
    return http.post(`${baseUrl}NewIndex/dateAll`, params)
  },
  //代订人列表页
  getPersonWhiteList(params) {
    return http.post(`${baseUrl}NewIndex/getPersonWhiteList`, params)
  },
  //添加代订人
  addPersonWhite(params) {
    return http.post(`${baseUrl}NewIndex/addPersonWhite`, params)
  },
  //编辑出行人员预定人
  editTravelWhiteByUser(params) {
    return http.post(`${baseUrl}NewIndex/editTravelWhiteByUser`, params)
  },
  //编辑员工预定人
  editPersonWhite(params) {
    return http.post(`${baseUrl}NewIndex/editPersonWhite`, params)
  },
  //删除预定人
  delPersonWhite(params) {
    return http.post(`${baseUrl}NewIndex/delPersonWhite`, params)
  },
  //企业概览
  OverviewList(params) {
    return http.post(`${baseUrl}Portal/OverviewList`, params)
  },
  //发票明细
  getInDetails(params) {
    return http.post(`${baseUrl}Company/getInDetails`, params)
  },
  //换开发票
  resetOrderReport(params) {
    return http.post(`${baseUrl}Company/resetOrderReport`, params)
  },
  //企业账期
  paymentPeriod(params) {
    return http.post(`${baseUrl}Company/paymentPeriod`, params)
  },
  //财务打款
  addApplyforFinance(params) {
    return http.post(`${baseUrl}ApprovalCenter/addApplyforFinance`, params)
  },
  //创建报销类型
  oaReviewListByFinance(params) {
    return http.post(`${baseUrl}OaApproval/oaReviewListByFinance`, params)
  },
 //国籍城市
  countrylist(params) {
    return http.post(`${baseUrl}User/countrylist`, params)
  },








}



// WEBPACK FOOTER //
// ./src/api/newCompany.js